import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import Portfolio from '../Portfolio';
import CtaStyle2 from '../Cta/CtaStyle2';
import { pageTitle } from '../../helpers/PageTitle';

const portfolioData = [
  {
    href: '/court/court-detail?type=padel&court=1',
    imgUrl: '/images/creative-agency/padelcourt1.jpeg',
    title: 'Padel Court 01',
    btnText: '',
  },
  {
    href: '/court/court-detail?type=padel&court=2',
    imgUrl: '/images/creative-agency/padelcourt2.jpeg',
    title: 'Padel Court 02',
    btnText: '',
  },
  {
    href: '/court/court-detail?type=padel&court=3',
    imgUrl: '/images/creative-agency/padelcourt3.jpeg',
    title: 'Padel Court 03',
    btnText: '',
  },
  {
    href: '/court/court-detail?type=padel&court=4',
    imgUrl: '/images/creative-agency/padel4.jpeg',
    title: 'Padel Court 04',
    btnText: '',
  },
  {
    href: '/court/court-detail?type=padel&court=5',
    imgUrl: '/images/creative-agency/padelcourt5.jpeg',
    title: 'Padel Court 05',
    btnText: '',
  },
  {
    href: '/court/court-detail?type=padel&court=6',
    imgUrl: '/images/creative-agency/padelcourt6.jpeg',
    title: 'Padel Court 06',
    btnText: '',
  },
  // {
  //   href: '/court/court-detail?type=Futsal&court=1',
  //   imgUrl: '/images/creative-agency/whyx.png',
  //   title: 'Futsal Court 01',
  //   btnText: '',
  // },
  // {
  //   href: '/court/court-detail?type=Futsal&court=2',
  //   imgUrl: '/images/creative-agency/portfolio_6.jpg',
  //   title: 'Futsal Court 02',
  //   btnText: '',
  // },
  {
    href: '/court/court-detail?type=multipurpose&court=1',
    imgUrl: '/images/creative-agency/multi.png',
    title: 'Multi-Purpose Court 01',
    btnText: '',
  },
];

export default function PortfolioPage() {
  pageTitle('Courts');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Discover our top-quality Padel, Futsal, and Multi Purpose courts."
        subTitle="Our Courts "
        shape="shape_3"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <Portfolio data={portfolioData} />
        <div className="cs_height_75 cs_height_lg_40" />
        <CtaStyle2
          title="Looking to Play or Train?"
          btnText="Send Message"
          btnUrl="/contact"
        />
        <div className="cs_height_120 cs_height_lg_80" />
      </div>
    </>
  );
}
